export const VisualizationsInfoCompaniesManagement = {
    chart_score: {
        description: `
        O <b>Nucont Score</b> calcula o engajamento da contabilidade com as empresas quanto aos <b>dados inseridos</b> na plataforma e as <b>entregas</b> do dash.
        <br><br>
        Procure manter as empresas com Score Alto, assegurando que os dados estejam atualizados e enviando regularmente os Dashes para seus clientes.
        <br><br>
        Veja no Drilldown à direita como está a a distribuição da sua carteira.
        <br><br>
        O cálculo é realizado da seguinte maneira:
        <br> 
        Score <b>geral</b> alto = Mais do que 50% das empresas ativas com Score Alto;<br>
        Score <b>geral</b> médio = Entre 30% e 50% das empresas ativas com Score Alto;<br>
        Score <b>geral</b> baixo = Menos do que 30% das empresas ativas com Score Alto.<br>
        `,

        formula: `Score \\space geral =\\frac{Quantidade\\space de\\space empresas\\space com\\space score\\space alto}{Quantidade\\space de\\space empresas\\space ativas}`,
        drillDown: [
            {
                _id: "score_high",
                name: "Score Alto",
                path: "high",
                serie: {
                    _id: "customers_with_deliveries",
                    name: "Clientes com entregas",
                    name_nd: "CLIENTES COM ENTREGAS",
                    unit: "percentage",
                    polarity: 1
                },
                visualization: {
                    _id: "customers_with_deliveries",
                    name: "Score Alto",
                    name_nd: "SCORE ALTO",
                    series: ["customers_with_deliveries"],
                    sources: ["accounting"],
                    chart: {
                        category: "donut",
                        chart: {
                            animation: true,
                            reflow: true,
                            type: "pie",
                            renderTo: {}
                        },
                        plotOptions: {
                            pie: {
                                dataLabels: {
                                    enabled: false
                                },
                                size: "90%",
                                slicedOffset: 0
                            },
                            series: {
                                enableMouseTracking: false,
                                states: {
                                    hover: {
                                        halo: {
                                            size: 1
                                        }
                                    }
                                }
                            }
                        },
                        series: [
                            {
                                _id: "customers_with_deliveries",
                                color: "cyan.medium",
                                data: [
                                    {
                                        color: "#00f5ff"
                                    },
                                    {
                                        color: "#e8ebeb"
                                    }
                                ],
                                dataLabels: {
                                    enabled: false
                                },
                                innerSize: "92%",
                                showInLegend: false
                            }
                        ],
                        title: {
                            align: "center",
                            style: {
                                color: "#00f5ff",
                                fontFamily: "Open Sans",
                                fontSize: "30px",
                                fontWeight: "bold"
                            },
                            verticalAlign: "middle",
                            y: 30
                        }
                    },
                    accountingId: "CONTABILIDADE_NUCONT",
                    companyId: "EMPRESA_NUCONT",
                    public: true
                },
                compound: [
                    {
                        _id: "customers_with_data",
                        name: "Clientes com input de dados",
                        path: "withEvents",
                        unit: "int",
                        serie: { _id: "customers_with_data" }
                    },
                    {
                        _id: "customers_with_deliveries",
                        name: "Clientes com entregas",
                        path: "withEvents",
                        unit: "int",
                        serie: { _id: "customers_with_deliveries" }
                    }
                ],
                description: `O <b>Score Alto</b> são as empresas que estão recebendo informações consultivas por meio de Dash e podem agregar valores a sua contabilidade.
                <br><br>
                Para isso, a empresa precisa ter os dados preenchidos nos últimos <b>3 meses</b> e ter compartilhado o Dash. `
            },
            {
                _id: "score_medium",
                name: "Score Médio",
                path: "medium",
                serie: {
                    _id: "customers_with_data",
                    name: "Clientes com input de dados",
                    name_nd: "CLIENTES COM INPUT DE DADOS",
                    unit: "percentage",
                    polarity: 1
                },
                visualization: {
                    _id: "customers_with_data",
                    name: "Score Médio",
                    name_nd: "SCORE MEDIO",
                    series: ["customers_with_data"],
                    sources: ["accounting"],
                    chart: {
                        category: "donut",
                        chart: {
                            animation: true,
                            reflow: true,
                            type: "pie",
                            renderTo: {}
                        },
                        plotOptions: {
                            pie: {
                                dataLabels: {
                                    enabled: false
                                },
                                size: "90%",
                                slicedOffset: 0
                            },
                            series: {
                                enableMouseTracking: false,
                                states: {
                                    hover: {
                                        halo: {
                                            size: 1
                                        }
                                    }
                                }
                            }
                        },
                        series: [
                            {
                                _id: "customers_with_data",
                                color: "yellow.medium",
                                data: [
                                    {
                                        color: "#00f5ff"
                                    },
                                    {
                                        color: "#e8ebeb"
                                    }
                                ],
                                dataLabels: {
                                    enabled: false
                                },
                                innerSize: "92%",
                                showInLegend: false
                            }
                        ],
                        title: {
                            align: "center",
                            style: {
                                color: "#00f5ff",
                                fontFamily: "Open Sans",
                                fontSize: "30px",
                                fontWeight: "bold"
                            },
                            verticalAlign: "middle",
                            y: 30
                        }
                    },
                    accountingId: "CONTABILIDADE_NUCONT",
                    companyId: "EMPRESA_NUCONT",
                    public: true
                },
                compound: [
                    {
                        _id: "customers_with_data",
                        name: "Clientes com input de dados",
                        path: "withEvents",
                        unit: "int",
                        serie: { _id: "customers_with_data" }
                    }
                ],
                description: `O <b>Score Médio</b> são as empresas que estão com os dados atualizados mas não estão recebendo as informações consultivas.
                <br><br>
                Para isso, a empresa precisa ter os dados preenchidos nos últimos <b>3 meses.</b>`
            },
            {
                _id: "score_low",
                name: "Score Baixo",
                path: "low",
                serie: {
                    _id: "customers_without_data",
                    name: "Clientes sem input de dados",
                    name_nd: "CLIENTES SEM INPUT DE DADOS",
                    unit: "percentage",
                    polarity: 1
                },
                visualization: {
                    _id: "customers_without_data",
                    name: "Score Baixo",
                    name_nd: "Score Baixo",
                    series: ["customers_without_data"],
                    sources: ["accounting"],
                    chart: {
                        category: "donut",
                        chart: {
                            animation: true,
                            reflow: true,
                            type: "pie",
                            renderTo: {}
                        },
                        plotOptions: {
                            pie: {
                                dataLabels: {
                                    enabled: false
                                },
                                size: "90%",
                                slicedOffset: 0
                            },
                            series: {
                                enableMouseTracking: false,
                                states: {
                                    hover: {
                                        halo: {
                                            size: 1
                                        }
                                    }
                                }
                            }
                        },
                        series: [
                            {
                                _id: "customers_without_data",
                                color: "purple.medium",
                                data: [
                                    {
                                        color: "#00f5ff"
                                    },
                                    {
                                        color: "#e8ebeb"
                                    }
                                ],
                                dataLabels: {
                                    enabled: false
                                },
                                innerSize: "92%",
                                showInLegend: false
                            }
                        ],
                        title: {
                            align: "center",
                            style: {
                                color: "#00f5ff",
                                fontFamily: "Open Sans",
                                fontSize: "30px",
                                fontWeight: "bold"
                            },
                            verticalAlign: "middle",
                            y: 30
                        }
                    },
                    accountingId: "CONTABILIDADE_NUCONT",
                    companyId: "EMPRESA_NUCONT",
                    public: true
                },
                compound: [
                    {
                        _id: "customers_without_data",
                        name: "Clientes sem input de dados",
                        path: "withoutEvents",
                        unit: "int",
                        serie: { _id: "customers_without_data" }
                    }
                ],
                description: `O <b>Score Baixo</b> são as empresas que estão ativas na Nucont mas não possuem dados atualizados.
                <br><br>
                Tenha <b>atenção</b> com estas empresas, pois elas podem estar em risco.`
            }
        ]
    }
};
